module.exports = __webpack_public_path__ + "static/img/bruderertrans.1fac6da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/bruderertrans.png
// module id = 476
// module chunks = 1